export default {
  "config": {
    "trial": "tones-5",
    "id": "teaes",
    "type": "table",
    "title": "TEAEs Across the Study (Safety Population, Groups A and B Combined)<sup>14</sup>",
    "footnotes": [
      "<sup>a</sup>Due to sepsis. Death was considered by investigator to be unrelated to study drug administration.",
      "<no-break><sup>b</sup>≥5%</no-break> in combined solriamfetol groups for any indication."
    ],
    "useFootnoteTooltip": false
  },
  "data": {
    "trial": "tones-5",
    "id": "teaes",
    "data-type": "table",
    "title": "TEAEs Across the Study (Safety Population, Groups A and B Combined)<sup>14</sup>",
    "num-header-rows": 2,
    "num-columns": 4,
    "col-classes": [
      "col-1",
      "sol",
      "sol",
      "sol"
    ],
    "row-mergeoption": [
      1,
      2,
      4,
      11
    ],
    "footnote-tooltip": "disable",
    "footnote-order": [
      "footnote-a",
      "footnote-b"
    ],
    "footnote-a": "<sup>a</sup>Due to sepsis. Death was considered by investigator to be unrelated to study drug administration.",
    "footnote-b": "<no-break><sup>b</sup>≥5%</no-break> in combined solriamfetol groups for any indication.",
    "data": {
      "row-0": [
        {
          "content": null,
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<center><b>Participants in combined solriamfetol groups, <no-break>n (%)</no-break></b></center>",
          "cols": 3,
          "class": "sol"
        }
      ],
      "row-1": [
        {
          "indent": 0,
          "content": "<b>TEAE</b>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "<b>Overall <no-break>(N = 643)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>OSA <no-break>(n = 417)</no-break></b>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "<b>Narcolepsy <no-break>(n = 226)</no-break></b>",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-2": [
        {
          "indent": 0,
          "content": "At least <no-break>one TEAE</no-break>",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "482 (75.0)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "313 (75.1)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "169 (74.8)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-3": [
        {
          "indent": 0,
          "content": "Severity of TEAEs",
          "cols": 4,
          "class": "col-1",
          "parentRow": true,
          "parent": 3
        }
      ],
      "row-4": [
        {
          "indent": 1,
          "parent": 3,
          "content": "Mild",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "188 (29.2)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "128 (30.7)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "60 (26.5)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-5": [
        {
          "indent": 1,
          "parent": 3,
          "content": "Moderate",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "246 (38.3)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "157 (37.6)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "89 (39.4)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-6": [
        {
          "indent": 1,
          "parent": 3,
          "content": "Severe",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "48 (7.5)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "28 (6.7)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "20 (8.8)",
          "parent": 3,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-7": [
        {
          "indent": 0,
          "content": "Serious TEAEs",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "27 (4.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "21 (5.0)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "6 (2.7)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-8": [
        {
          "indent": 0,
          "content": "TEAEs leading to discontinuation",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "59 (9.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "36 (8.6)",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "23 (10.2)",
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-9": [
        {
          "indent": 0,
          "content": "Death",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "1 (0.2)<sup>a</sup>",
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "1 (0.2)",
          "cols": 1,
          "class": "sol"
        },
        {
          "content": 0,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-10": [
        {
          "indent": 0,
          "content": "Most common TEAEs<sup>b</sup>",
          "cols": 4,
          "class": "col-1",
          "parentRow": true,
          "parent": 10
        }
      ],
      "row-11": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Headache",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "71 (11.0)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "40 (9.6)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "31 (13.7)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-12": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Nausea",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "57 (8.9)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "31 (7.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "26 (11.5)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-13": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Nasopharyngitis",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "54 (8.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "35 (8.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "19 (8.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-14": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Insomnia",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "51 (7.9)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "35 (8.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "16 (7.1)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-15": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Dry mouth",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "47 (7.3)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "33 (7.9)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (6.2)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-16": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Anxiety",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "46 (7.2)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "25 (6.0)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "21 (9.3)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-17": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Decreased appetite",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "32 (5.0)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "14 (3.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "18 (8.0)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ],
      "row-18": [
        {
          "indent": 1,
          "parent": 10,
          "content": "Upper respiratory tract infection",
          "cols": 1,
          "class": "col-1"
        },
        {
          "indent": 0,
          "content": "32 (5.0)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "22 (5.3)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        },
        {
          "indent": 0,
          "content": "10 (4.4)",
          "parent": 10,
          "cols": 1,
          "class": "sol"
        }
      ]
    }
  }
};